import { fetchJson } from '~/utils/fetch-json-v2';

export interface KYCStartResponse {
  id: string;
  user_urn: string;
  provider: string;
  status: string;
  verification_url: string;
  external_id: string;
  created_at: string;
}

export interface KYCStatusResponse {
  id: string;
  provider: string;
  status: 'initiated' | 'approved' | 'rejected';
  verification_url?: string;
  created_at: string;
}

export async function startKYCVerification(
  urn: string,
  type?: string,
  redirect_url?: string,
) {
  return fetchJson<KYCStartResponse>('/compliance', {
    method: 'POST',
    body: { urn, type, redirect_url },
  });
}

export async function getKYCStatus(urn: string) {
  return fetchJson<KYCStatusResponse>(`/compliance/${urn}`, {
    method: 'GET',
  });
}
